@if (vehicle()) {
  @if (mode() === 'detail') {
    <div class="eval-fill-total-label mb-3">
      <i class="material-icons">trending_up</i>
      Porcentagem de preenchimento do RaioX
    </div>
    
    <div class="eval-fill-total">
      <div class="eval-fill-progress-circle" 
           [ngClass]="[getProgressClass(), (getTotalEvalFilled() <= 0 ? 'is-empty' : '')]"
           [style.--percentage]="getProgressWidth()">
        
        <svg viewBox="0 0 100 100" class="circular-chart">
          <circle class="circular-bg" cx="50" cy="50" r="40"></circle>
          <circle class="circular-fill" cx="50" cy="50" r="40"></circle>
        </svg>
    
        <span class="eval-fill-progress-text">
          {{ formatPercentage(getTotalEvalFilled()) }}%
        </span>
    
      </div>
      <div class="eval-progress-info">
        Complete o preenchimento das informações para obter uma avaliação mais precisa do veículo.
  
        <div class="eval-fill-progress-info-text">
          {{ formatPercentage(getTotalEvalFilled()) }}% concluído
        </div>
      </div>
    </div>
  } @else {
    <div class="eval-fill-total is-card-mode">
      <div class="eval-fill-total-label">
        Porcentagem de preenchimento do RaioX
      </div>
    
      <div class="eval-fill-progress" [ngClass]="[getProgressClass(), (getTotalEvalFilled() <= 0 ? 'is-empty' : '')]">
        <div class="eval-fill-progress-fill" [style.width.%]="getProgressWidth()"></div>
    
        <span class="eval-fill-progress-text" [ngStyle]="{color: getTotalEvalFilled() < 50 ? '#000' : '#fff'}">
          {{ formatPercentage(getTotalEvalFilled()) }}%
        </span>
      </div>
    </div>
  }
}